module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo02-662c7ee2e2da82c0c6032d9d8bafdf4d.svg";